<script lang="ts">import OtpInput from "./parts/input.svelte";
import { cfgBrandTitle } from "@infinitro/config";
import { Verbiage, t } from "@infinitro/content";
import { ModalDialog, Stage, closeThisModal, modalStack, stage } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import { onDestroy, onMount } from "svelte";
import { derived } from "svelte/store";
import { TOTP } from "totp-generator";
import Timer from "./parts/timer.svelte";
const thisModal = ModalDialog.TotpSetup;
const modalIndex = derived(modalStack, ($modalStack) => $modalStack.findIndex((e) => e.modal === thisModal));
const isModalOpen = derived(modalIndex, ($modalIndex) => $modalIndex >= 0);
const payload = derived(modalStack, ($modalStack) => $modalStack.find((e) => e.modal === thisModal)?.data);
const zOverlay = derived(modalIndex, ($modalIndex) => $modalIndex >= 0 ? 9999 + $modalIndex * 2 : 9999);
const DEBUG = stage !== Stage.Prod;
const brand_title = cfgBrandTitle();
const STEP = 30;
const GRACE = 5e3;
let interval = undefined;
let totp = {
	otp: "",
	expires: 0
};
function log(msg) {
	if (DEBUG) console.log(msg);
}
const sleep = (ms = 0) => new Promise((resolve) => setTimeout(resolve, ms));
const getTotpSecret = () => {
	let uri = `otpauth://totp/${brand_title}:${$payload?.label ?? ""}?secret=${$payload?.secret ?? ""}`;
	return uri;
};
const closeModal = () => {
	if ($payload?.onClose && typeof $payload.onClose === "function") {
		$payload.onClose();
	}
	closeThisModal(thisModal);
};
const handleSetupComplete = async (secret, otp) => {
	const success = await $payload?.onSetupComplete(secret, otp);
	if (success && interval) clearInterval(interval);
	return success ?? false;
};
const DELAY_TO_DISPLAY_SUCCESS = 500;
const handleOtpChange = async (otpCode) => {
	if (!$payload?.secret) return false;
	totp = TOTP.generate($payload?.secret);
	if (otpCode == totp.otp) {
		await sleep(DELAY_TO_DISPLAY_SUCCESS);
		await handleSetupComplete($payload?.secret, totp.otp);
		return true;
	}
	totp = TOTP.generate($payload?.secret, { timestamp: Date.now() - GRACE });
	if (otpCode == totp.otp) {
		await sleep(DELAY_TO_DISPLAY_SUCCESS);
		await handleSetupComplete($payload?.secret, totp.otp);
		return true;
	}
	totp = TOTP.generate($payload?.secret, { timestamp: Date.now() + GRACE });
	if (otpCode == totp.otp) {
		await sleep(DELAY_TO_DISPLAY_SUCCESS);
		await handleSetupComplete($payload?.secret, totp.otp);
		return true;
	}
	return false;
};
const debugTotp = () => {
	totp = TOTP.generate($payload?.secret);
	log(`code [${totp.otp}] expires in ${Math.ceil((totp.expires - Date.now()) / 1e3)} seconds`);
};
onMount(async () => {
	if (!$payload?.secret) console.error("secret is required");
	totp = TOTP.generate($payload?.secret);
	if (!DEBUG) return;
	debugTotp();
	await sleep(totp.expires - Date.now() + 1);
	debugTotp();
	interval = setInterval(() => debugTotp(), STEP * 1e3);
});
onDestroy(() => {
	if (interval) clearInterval(interval);
	log("totp setup timer cleared");
});
</script>

{#if $isModalOpen}
	<Modal
		{closeModal}
		noAnimation={$payload?.noAnimation ?? false}
		title={$payload?.title ?? $t(Verbiage.totp_setup)}
		zIndexOverlay={$zOverlay}
		zIndexUnderlay={$zOverlay - 1}
	>
		<div class="content">
			<p class="text">
				{`${$payload?.content ?? $t(Verbiage.scan_verify)}`}
			</p>
			<p class="qr">
				<Timer secret={$payload?.secret} label={$payload?.label} />
			</p>
			<p class="text">
				{`${$t(Verbiage.enter_verify)}`}
			</p>
			<OtpInput numInputs={$payload?.numInputs ?? 6} {handleOtpChange} />
		</div>
	</Modal>
{/if}

<style>
	.content {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-between
}
.content > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse))
}
	.text {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    text-align: center;
    font-size: 1.875rem;
    line-height: 2.25rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
	p.qr {
    display: flex;
    justify-content: center
}
</style>
